import { OrdersCustomModalCell } from './components/order-custom-modal-cell';
import { OrdersCustomModalSubValueCell } from './components/order-custom-modal-subvalue-cell';

export const FORM_NAME = 'orders-form';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ORDER_TABLE_COLUMNS_NAMES = [
	{ id: 'title', width: '332px' },
	{ id: 'value', width: '305px', customComponent: OrdersCustomModalCell },
	{ id: 'sub_value', customComponent: OrdersCustomModalSubValueCell },
];

export const ORDER_TABLE_ROWS_NAMES = {
	customer: 'Заказчик',
	number: 'Номер заказа',
	created_date: 'Дата создания заказа',
	address_from: 'Адрес отгрузки',
	pickup_at: 'Планируемая дата отгрузки',
	mode: 'Температурный режим',
	cargo: 'Габаритные характеристики',
	cost: 'Заявленная стоимость груза',
	attr_group: 'Атрибут группы',
	attr_way: 'Атрибут маршрута',
	comment: 'Примечание',
	address_to: 'Адрес доставки',
	drop_at: 'Планируемая дата доставки',
};

export const DATE_FORMAT = 'DD.MM.YYYY';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const SINGLE_COLUMN_ROWS = ['number', 'mode', 'cargo', 'cost', 'comment'];

export const ORDERS_FORM_FIELDS_NAMES = [
	'customer_id',
	'number',
	'points.0',
	'mode.id',
	'cost',
	'weight',
	'volume',
	'place',
	'comment',
	'points.1',
];

export const ORDERS_FORM_REQUIRED_FIELDS = ['customer_id', 'points.0', 'mode.id', 'weight', 'volume', 'points.1'];

export const FROM_POINT_REQUIRED_FIELDS = ['partner', 'address', 'contact'];

export const TO_POINT_REQUIRED_FIELDS = ['partner', 'address', 'date', 'contact'];
